import api from './config';

export const getCreditosISR = (companyId, params = {}) =>
  api.get('/creditos-isr', { params: { companyId, ...params } }).then(r => r.data);

export const getCreditoISR = (id, companyId) =>
  api.get(`/creditos-isr/${id}`, { params: { companyId } }).then(r => r.data);

export const getStatsISR = (companyId) =>
  api.get('/creditos-isr/stats', { params: { companyId } }).then(r => r.data);

export const crearCreditoManual = (data) =>
  api.post('/creditos-isr', data).then(r => r.data);

export const cancelarCredito = (id, companyId, motivo) =>
  api.put(`/creditos-isr/${id}/cancelar`, { companyId, motivo }).then(r => r.data);
